import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';

@Component({
  selector: 'app-provider-management',
  templateUrl: './provider-management.component.html',
  styleUrls: ['./provider-management.component.css']
})
export class ProviderManagementComponent implements OnInit {

  constructor(public router: Router) {
    this.router.url
   }

  ngOnInit() {
  }

}
